import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const EventCalendar = (props: any) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Link to={`/event-calendar/events/all`}>
        <button
          type="button"
          className={`btn header-item noti-icon ${window.location.pathname === "/event-calendar/events/all" ? "header-icon-active" : ""}`}
          title={t("Events")}
        >
          <span className="align-middle material-symbols-outlined fw-light">
            event_note
          </span>
        </button>
      </Link>
    </React.Fragment>
  );
};

export default EventCalendar;
